import ArticleContentEditor from './article-content-editor';

export default ArticleContentEditor;
